import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "react-bootstrap";
import { Building, Calendar2, TextParagraph } from "react-bootstrap-icons";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const allowedExtensions = ["zip", "x-zip-compressed"];

export default function HotspotInfos({ codehotspot }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [starting, setstarting] = useState(false);
    const [validing, setvaliding] = useState(false);
    const [suspending, setsuspending] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [validstate, setvalidstate] = useState(false);
    const [error, setError] = useState(false);

    const [lib, setlib] = useState("");
    const [desc, setdesc] = useState("");
    const [site, setsite] = useState('');
    const [sitesList, setsitesList] = useState([]);
    const [revendeur, setrevendeur] = useState('');
    const [revendeursList, setrevendeursList] = useState([]);
    const [portail, setportail] = useState('');

    const [datecrea, setDatecrea] = useState("");
    const [etatdef, setetatdef] = useState("");
    const [etat, setEtat] = useState(0);


    const currentdate = new Date()
        .toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getRevendeursList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            // if (element.abrevtypeutilisateur === "RVD") {
                            //     clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });
                            // }
                            clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });

                        });

                        setrevendeursList(clientarraydata);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            console.log("error get reventeurs list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getSiteList = async (prevendeur) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?coderevendeur=${prevendeur}&etat=2`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.nom, value: element.code });
                        });


                        setsitesList(clientarraydata);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            // console.log("error get client list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getSiteList2 = async () => {

        if (!user?.isFullAction && !user?.isAdminAction) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.app.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?coderevendeur=${user?.codeutilisateur}&etat=2`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let clientarray = [];

                            clientarray = data?.body?.data;

                            let clientarraydata = [];
                            await clientarray.forEach(element => {
                                clientarraydata.push({ label: element.nom, value: element.code });
                            });


                            setsitesList(clientarraydata);
                        } else {
                            if (data?.body?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // console.log("server error", err);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    // console.log("statut error", err);
                }

            }).catch((err) => {
                // console.log("error get client list", err);
                // setError(true);
                // setLoading(false);
            });
        }

    }

    const getElement = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/hotspots/${codehotspot}?page=0`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setlib(body?.lib !== null ? body?.lib : "");
                        setdesc(body?.desc !== null ? body?.desc : "");
                        setportail((body?.portail !== null) ? body?.portail : null);

                        setrevendeur(
                            body?.coderevendeur ? { label: body?.nomuser + " " + body?.prenom, value: body?.coderevendeur, } : ""
                        );
                        setsite(
                            body?.codesite ? { label: body?.nomsite, value: body?.codesite, } : ""
                        );
                        setetatdef(body?.etatdef !== null ? body?.etatdef : "");
                        setEtat(body?.etat !== null ? body?.etat : "");

                        // setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDatecrea(
                            body?.datecrea !== null
                                ? body?.datecrea.slice(0, 16).replace("T", " à ")
                                : ""
                        );

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    };

    const handleChangeFileapk = (e) => {
        const file = e.target.files[0];

        const fileExtension = file?.type.split("/")[1];

        console.log("file: ", file);
        console.log("file type: ", file?.type);
        console.log("extention: ", fileExtension);
        console.log("path absolute: ", URL.createObjectURL(file));

        if (!allowedExtensions.includes(fileExtension)) {
            showErrorMessage("Veuillez sélectionner un fichier zip");
            return;
        } else {
            // setportail(file);
            // setlib(file?.name.split("-")[0]);
            TransformFileapk(file);
        }

        // console.log("recto prev", rectoprev)
    };

    const TransformFileapk = (file) => {
        const reader = new FileReader();
        if (file) {
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setportail(reader.result);
            };
        } else {
            setportail(null);
        }
    };

    // comportements
    useEffect(() => {
        getElement();
        getRevendeursList();
        getSiteList2();
    }, []);

    const handleDelete = async () => {
        confirmAlert({
            title: textes.fr.deletehotspotlabel,
            message: textes.fr.deletehotspotlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: "DELETE",
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: "follow",
                        };

                        // console.log("data send", urlencoded);

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/hotspots/${codehotspot}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage(textes.fr.hotspotdeletedlabel);
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            }
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setDeleting(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.edithotspotlabel,
            message: textes.fr.edithotspotlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();
                        if (lib) urlencoded.append("lib", lib);
                        if (desc) urlencoded.append("descr", desc);
                        if (site) urlencoded.append("codesite", site["value"]);
                        urlencoded.append("etatdef", etatdef);
                        urlencoded.append("defaut", false);
                        urlencoded.append("edit", true);

                        // console.log("data send", urlencoded)

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/hotspots/${codehotspot}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage(textes.fr.hotspotupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setFetching(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSuspende = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.edithotspotlabel,
            message: textes.fr.edithotspotlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setsuspending(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "3");
                        urlencoded.append("etatdef", "Suspendu");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/hotspots/${codehotspot}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.hotspotupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setsuspending(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setsuspending(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setsuspending(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setsuspending(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleStart = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.edithotspotlabel,
            message: textes.fr.edithotspotlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setstarting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Validé");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/hotspots/${codehotspot}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.hotspotupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setstarting(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setstarting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setstarting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setstarting(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleValide = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.edithotspotlabel,
            message: textes.fr.edithotspotlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setvaliding(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (portail) urlencoded.append("portail", portail);
                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Validé");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/hotspots/${codehotspot}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.hotspotupdatedlabel);
                                setEditedstate(false);
                                setvalidstate(false);
                                getElement();
                                setvaliding(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setvaliding(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setvaliding(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setvaliding(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <button
                                            onClick={() => navigate(-1)}
                                            data-toggle="tooltip"
                                            title={textes.fr.back}
                                            data-placement="left"
                                            className="btn-shadow ml-3 btn btn-dark btn-sm float-right"
                                        >
                                            <i className="fa fa-reply"></i>{" "}
                                            <span>{textes.fr.back}</span>
                                        </button>
                                        {(user?.isFullAction || user?.isAdminAction || user?.isModifierHotspot) && !editedstate && (
                                            <button
                                                onClick={() => setEditedstate(true)}
                                                title={textes.fr.edithotspotlabel}
                                                className="btn-shadow ml-3 btn btn-success btn-sm float-right"
                                            >
                                                <i className="fa fa-edit mr-1"></i>{" "}
                                                <span>{textes.fr.edit}</span>
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isSupprimerHotspot) && !editedstate && (etat === 1 || etat === 3) && (
                                            <button
                                                onClick={handleDelete}
                                                title={textes.fr.deletehotspotlabel}
                                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                            >
                                                <i className="fa fa-trash mr-1"></i>{" "}
                                                <span>{textes.fr.delete}</span>{" "}
                                                {deleting && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isValiderHotspot) && !editedstate && etat === 1 && <button
                                            onClick={() => {
                                                setvalidstate(true);
                                                setEditedstate(true);
                                            }}
                                            title="Valider le hotspot"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                            <i className="fa fa-check-circle mr-1"></i> <span>Valider</span>
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isActiverHotspot) && !editedstate && etat === 3 && <button onClick={handleStart}
                                            title="Réactiver le hotspot"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                            <i className="fa fa-arrow-up mr-1"></i> <span>Ré-activer</span>  {starting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isSuspendreHotspot) && !editedstate && etat === 2 && <button onClick={handleSuspende}
                                            title="Suspendre le hotspot"
                                            className="btn-shadow ml-3 btn btn-warning btn-sm float-right">
                                            <i className="fa fa-arrow-down mr-1"></i> <span>Suspendre</span>  {suspending && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {!editedstate && portail && <a href={portail}
                                            target="_blank" rel="noreferrer" download={`Portail ${currentdate}-${revendeur["label"]}`}
                                            title="Télécharger le portail"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right"
                                        >
                                            <i className="fa fa-download mr-1"></i>{" "}
                                            <span>Télécharger</span>
                                        </a>}
                                        <h5 className="m-0 ">
                                            {textes.fr.hotspotinfoslabel}
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {!validstate && <form style={{ width: "100%" }} className="mb-3" onSubmit={handleSubmitEdit}>
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div className="row">
                                                        {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                            <label htmlFor="revendeur" className="mb-1">
                                                                {textes.fr.revendeurlabel}
                                                            </label>
                                                            <Select
                                                                id="revendeur"
                                                                name="revendeur"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={revendeursList}
                                                                value={revendeur}
                                                                onChange={(selected) => {
                                                                    setrevendeur(selected);
                                                                    if (selected) {
                                                                        getSiteList(selected["value"]);
                                                                    } else {
                                                                        setsitesList([]);
                                                                    }
                                                                    // getSiteList(selected["value"]);
                                                                }}
                                                                isClearable
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>}
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="site" className="mb-1">
                                                                {textes.fr.sitelabel}
                                                            </label>
                                                            <Select
                                                                id="site"
                                                                name="site"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={sitesList}
                                                                value={site}
                                                                onChange={(selected) => {
                                                                    setsite(selected);
                                                                }}
                                                                isClearable
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="lib" className="mb-1">
                                                                Libelle
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="lib"
                                                                >
                                                                    <Building />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={lib}
                                                                    onChange={(e) =>
                                                                        setlib(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="desc" className="mb-1">
                                                                Description
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="desc"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <textarea
                                                                    className="form-control"
                                                                    placeholder={
                                                                        textes.fr.descriptionlabel
                                                                    }
                                                                    value={desc}
                                                                    style={{ height: 154 }}
                                                                    onChange={(e) =>
                                                                        setdesc(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="etat" className="mb-1">Etat</label>
                                                            <div className="input-group flex-nowrap">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    className={`form-control 
                                                                        ${etat === 1 ? "text-white bg-warning" :
                                                                            etat === 2 ? "text-white bg-success" :
                                                                                etat === 3 ? "text-white bg-danger" :
                                                                                    ""
                                                                        }`}
                                                                    id="etat"
                                                                    value={etatdef}
                                                                    onChange={(e) => setEtat(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="dateadd" className="mb-1">
                                                                {textes.fr.addeddatelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="dateadd">
                                                                    <Calendar2 />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={datecrea}
                                                                    onChange={(e) => setDatecrea(e.target.value)}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {editedstate && (
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.edithotspotlabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Modifier</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => setEditedstate(false)}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </form>}
                                        {validstate && <form style={{ width: "100%" }} className="mb-3" onSubmit={handleValide}>
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="site" className="mb-1">
                                                                {textes.fr.sitelabel}
                                                            </label>
                                                            <Select
                                                                id="site"
                                                                name="site"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={sitesList}
                                                                value={site}
                                                                onChange={(selected) => {
                                                                    setsite(selected);
                                                                }}
                                                                isClearable
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="lib" className="mb-1">
                                                                Hotspot
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="lib"
                                                                >
                                                                    <Building />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={lib}
                                                                    onChange={(e) =>
                                                                        setlib(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="portail" className="form-label">Portail</label>
                                                            <input className="form-control" type="file" id="portail" onChange={handleChangeFileapk} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-2">
                                                    <button
                                                        type="submit"
                                                        title={textes.fr.edithotspotlabel}
                                                        className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                        disabled={portail ? false : true}
                                                    >
                                                        <i className="fa fa-check mr-2"></i>
                                                        <span>Valider</span>{" "}
                                                        {validing && (
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        )}
                                                    </button>
                                                    <button
                                                        onClick={() => { setEditedstate(false); setvalidstate(false) }}
                                                        title={textes.fr.cancel}
                                                        className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                    >
                                                        <i className="fa fa-reply mr-1"></i>{" "}
                                                        <span>{textes.fr.cancel}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
